import { makeAutoObservable } from 'mobx';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import API_URL from '../../config/ApiUrl';
import axios from 'axios';

export default class TempleStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	templeBasicDetail = null;
	templeTimingDetail = null;
	templeImageDetails = null;
	searchValue = '';

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.TEMPLE.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addTemple = async (formData) => {
		return await axios
			.post(API_URL.TEMPLE.ADD, formData)
			.then(({ data }) => {
				if (!data.data.errorMessage) {
					return data;
				} else {
					return data.data.errorMessage;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	addRoutine = async (formData) => {
		return await axios
			.post(API_URL.TEMPLE.ROUTINEDETAILS, formData)
			.then(({ data }) => {
				if (!data.data.errorMessage) {
					return data;
				} else {
					return data.data.errorMessage;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	updateRoutine = async (formData) => {
		return await axios
			.put(API_URL.TEMPLE.UPDATEROUTINEDETAILS, formData)
			.then(({ data }) => {
				if (!data.data) {
					return data;
				} else {
					return data.data.errorMessage;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	ReadTempleBasicList = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.TEMPLE.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.templeBasicDetail = data.data;
			return data.data;
		} catch {}
	};

	ReadTempleTimingdetail = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.TEMPLE.GETTEMPLETIMING + '?id=' + encodeURIComponent(id)
			);
			this.templeTimingDetail = data.data;
			return data.data;
		} catch {}
	};

	ReadTempleImagedetail = async (formData) => {
		try {
			const { data } = await axios.get(`
				${API_URL.TEMPLE.GETTEMPLEIMAGE}?refTablename=${formData.tableName}&refId=${encodeURIComponent(formData.templeID)}`);
			this.templeImageDetails = data.data;
			return data.data;
		} catch {}
	};

	deleteTemple = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.TEMPLE.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	editTemple = async (formData) => {
		return await axios
			.put(API_URL.TEMPLE.UPDATE, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	bulkImport = async (formData) => {
		return await axios
			.post(API_URL.TEMPLE.BULKIMPORT, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
}
